import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Field, Formik } from "formik";
import { get, isEmpty } from "lodash";
import React from "react";
import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useDeepEffect, useRequest } from "../../../abstracts";
import {
  FieldDropSide,
  FieldInput,
  LoaderWrapper,
  ManageReportLayout,
  SearchableList,
  DatePicker,
  MultiSelectDropdown,
} from "../../../components";
import {
  getCompaniesDropDown,
  getForfeitureSummaryReportInfo,
  getMasterPlanList,
  getPlansDropDown,
  getSponsorOrganizationList,
  getVestingReductionReport,
} from "../../../services";
import {
  formFields,
  manageReportsFormNames,
  clearFieldValues,
  usDateFormat,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  EMPLOYEE_RECORDS_TO_FETCH,
} from "../../../utils";
import { ColumnMenu } from "../PeriodicCensus/columnMenu";

const temporaryData = [
  {
    planId: 123,
    uniquePersonalIdentification: "123812",
    firstName: "abc",
    lastName: "def",
    sourceName: "ghi",
    previousYOS: 2,
    updatedYOS: 3,
    previousVestedPercentage: 7,
    updatedVestedPercentage: 8,
    runDate: "10/01/2023",
  },
  {
    planId: 315,
    uniquePersonalIdentification: "156211",
    firstName: "ghi",
    lastName: "jkl",
    sourceName: "mno",
    previousYOS: 12,
    updatedYOS: 15,
    previousVestedPercentage: 4,
    updatedVestedPercentage: 5,
    runDate: "12/04/2023",
  },
  {
    planId: 221,
    uniquePersonalIdentification: "128111",
    firstName: "mno",
    lastName: "pqr",
    sourceName: "uvw",
    previousYOS: 1,
    updatedYOS: 3,
    previousVestedPercentage: 6,
    updatedVestedPercentage: 7,
    runDate: "08/02/2023",
  },
];

const columns = [
  {
    value: 1,
    label: "Plan ID",
    className: "column-planId",
    columnName: "planId",
    field: "rkPlanNumber",
    width: 111,
    dataType: "alphaNumeric",
    field1: "rkPlanNumber",
  },
  {
    value: 2,
    label: "SSN",
    className: "column-ssn",
    columnName: "uniquePersonalIdentification",
    field: "uniquePersonalIdentification",
    width: 111,
    dataType: "alphaNumeric",
    field1: "uniquePersonalIdentification",
  },
  {
    value: 3,
    label: "First Name",
    className: "column-firstName",
    columnName: "firstName",
    field: "firstName",
    width: 144,
    dataType: "alphaNumeric",
    field1: "firstName",
  },
  {
    value: 4,
    label: "Last Name",
    className: "column-lastName",
    columnName: "lastName",
    field: "lastName",
    width: 149,
    dataType: "alphaNumeric",
    field1: "lastName",
  },
  {
    value: 5,
    label: "Source Name",
    className: "column-lastName",
    columnName: "sourcename",
    field: "sourcename",
    width: 149,
    dataType: "alphaNumeric",
    field1: "sourcename",
  },
  {
    value: 6,
    label: "Previous YOS",
    className: "column-lastName",
    columnName: "previousYOS",
    field: "previousYOS",
    width: 150,
    dataType: "numeric",
    field1: "previousYOSFrom",
    field2: "previousYOSTo",
  },
  {
    value: 7,
    label: "Updated YOS",
    className: "column-lastName",
    columnName: "updatedYOS",
    field: "updatedYOS",
    width: 150,
    dataType: "numeric",
    field1: "updatedYOSFrom",
    field2: "updatedYOSTo",
  },
  {
    value: 8,
    label: "Previous Vested %",
    className: "column-lastName",
    columnName: "previousVestedPercentage",
    field: "previousVestedPercentage",
    width: 150,
    dataType: "decimal",
    field1: "previousVestedPercentageFrom",
    field2: "previousVestedPercentageTo",
  },
  {
    value: 9,
    label: "Updated Vested %",
    className: "column-payDate",
    columnName: "updatedVestedPercentage",
    field: "updatedVestedPercentage",
    width: 150,
    dataType: "decimal",
    field1: "updatedVestedPercentageFrom",
    field2: "updatedVestedPercentageTo",
  },
  {
    value: 10,
    label: "Run date",
    className: "column-payDate",
    columnName: "runDate",
    field: "runDate",
    width: 120,
    dataType: "date",
    field1: "runDateFrom",
    field2: "runDateTo",
  },
];
const VestingReductionReportContainer = () => {
  const today = new Date();
  const formName = manageReportsFormNames.VESTING_REDUCTION_REPORT;
  const fields = formFields[formName];
  const [planList, setPlanList] = useState([]);
  const [final, setFinal] = useState(columns);
  const [lastScrollTop, setLastScrollTop] = useState(null);
  const [filteredValues, setFilteredValues] = useState({
    from: 0,
    numberOfRecordsToBeFetched: EMPLOYEE_RECORDS_TO_FETCH,
    companyId: 0,
    planId: 0,
    sponsorOrganizationId: 0,
    endDate: new Date(today.setDate(today.getDate())),
    startDate: new Date(today.setDate(today.getDate() - 30)),
    employeeNameOrSsn: "",
  });
  const [totalRecord, setTotalRecord] = useState(0);
  const [isScroll, setIsScroll] = useState(false);
  const [vestingReductionData, setVestingReductionData] = useState([]);
  const [gridFilters, setGridFilters] = useState();
  const [pageCount, setPageCount] = useState(1);
  const [sorting, setSorting] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
  ]);

  const allOption = { label: "All", value: null };

  const { response: companies } = useRequest({
    method: getCompaniesDropDown,
    defaultResponse: [],
  });

  const { response: sponsors } = useRequest({
    method: getSponsorOrganizationList,
    defaultResponse: [],
  });

  class KendoGridDecimalCell extends React.Component {
    render() {
      const field = this.props.field;
      const value = this.props.dataItem[this.props.field];
      return <td>$ {value}</td>;
    }
  }

  class KendoGridForfeitureEventCell extends React.Component {
    render() {
      const field = this.props.field;
      const value = this.props.dataItem[this.props.field];

      return <td>{value == 0 ? "Full Distribution" : "5 Years BIS"}</td>;
    }
  }

  class KendoGridForfeitureStatusCell extends React.Component {
    render() {
      const value = this.props.dataItem[this.props.field];
      return <td>{value == 0 ? "InProgress" : "Completed"}</td>;
    }
  }

  class ProductNameHeader extends React.Component {
    render() {
      return (
        <a className="k-link" onClick={this.props.onClick}>
          <span title={this.props.title}>{this.props.title}</span>
          {this.props.children}
        </a>
      );
    }
  }

  const renderValue = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;

    return <td>{value || value === 0 ? <div>{value}</div> : <div> -</div>}</td>;
  };

  const renderValueDate = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;

    return (
      <td>
        {value || value === 0 ? (
          <div>{usDateFormat(value)}</div>
        ) : (
          <div> -</div>
        )}
      </td>
    );
  };

  const dateForm = (props) => {
    var value = usDateFormat(props.dataItem[props.field]);
    return renderValue(value);
  };
  const apiCall = (data) => {
    setDataLoading(true);
    getVestingReductionReport(data)
      .then((response) => {
        setDataLoading(false);
        setVestingReductionData(response);
        setTotalRecord(response.length);
        if (response.length > 0) {
          setIsScroll(true);
        }
      })
      .catch((error) => {
        setDataLoading(false);
      });
  };

  useDeepEffect(() => {
    apiCall({
      ...filteredValues,
      innerFilters: gridFilters,
    });
    // if (!isEmpty(companyList) || !isEmpty(sponsorList)) {
    //   setFilteredValues({
    //     ...filteredValues,
    //     innerFilters: gridFilters,
    //   });
    //   apiCall({
    //     ...filteredValues,
    //     innerFilters: gridFilters,
    //   });
    // }
  }, [gridFilters]);

  const onSubmit = (values) => {
    var filters = {
      companyId: values.companyId ? values.companyId : 0,
      sponsorOrganizationId: values.sponsorOrganizationId
        ? values.sponsorOrganizationId
        : 0,
      planId: values.planId,
      employeeNameOrSsn: values.employeeNameOrSsn,
      startDate: usDateFormat(values.startDate),
      endDate: usDateFormat(values.endDate),
      from: 0,
      numberOfRecordsToBeFetched: EMPLOYEE_RECORDS_TO_FETCH,
      innerFilters: gridFilters,
    };
    apiCall(filters);
  };

  const scrollHandler = (event) => {
    const e = event.nativeEvent;
    if (lastScrollTop === e.target.scrollTop) {
      return;
    }
    setLastScrollTop(e.target.scrollTop);
    if (
      e.target.scrollTop + 20 >=
      e.target.scrollHeight - e.target.clientHeight
    ) {
      if (isScroll) {
        var fromCount = pageCount * 20 + 1;
        var filters = {
          companyId: filteredValues.companyId ? filteredValues.companyId : 0,
          sponsorOrganizationId: filteredValues.sponsorOrganizationId
            ? filteredValues.sponsorOrganizationId
            : 0,
          planId: filteredValues.sponsorOrganizationId
            ? planList.length === 1
              ? planList[0].planId
              : !filteredValues.planId
              ? 0
              : filteredValues.planId
            : 0,
          employeeNameOrSsn: filteredValues.employeeNameOrSsn,
          startDate: usDateFormat(filteredValues.startDate),
          endDate: usDateFormat(filteredValues.endDate),
          from: fromCount,
          numberOfRecordsToBeFetched: EMPLOYEE_RECORDS_TO_FETCH,
          innerFilters: gridFilters,
        };
        setToggle(!toggle);
        setPageCount(pageCount + 1);
        setDataLoading(true);
        getVestingReductionReport(filters)
          .then((response) => {
            setDataLoading(false);
            setVestingReductionData(response);
            setTotalRecord(response.count);
            if (response.count > 0) {
              setIsScroll(true);
            }
          })
          .catch((error) => {
            setDataLoading(false);
          });
      }
    }
  };

  const setToday = new Date();
  const [initialValues, setInitialValues] = useState({
    companyId: null,
    [fields.endDate]: new Date(setToday.setDate(setToday.getDate())),
    [fields.startDate]: new Date(setToday.setDate(setToday.getDate() - 30)),
  });

  return (
    <ManageReportLayout rptName="Vesting Reduction Report">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={{
              ...initialValues,
            }}
            onSubmit={onSubmit}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setErrors,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };

              const onPlanChange = (value) => {
                if (value || value === 0) {
                  setFieldValue(
                    fields.planId,
                    parseInt(planList[value].planId)
                  );
                  setFieldValue(fields.planName, planList[value].planName);
                } else {
                  setFieldValue(fields.planId, null);
                  setFieldValue(fields.planName, "All");
                }
              };

              const onCompanyChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    fieldsToClear: [fields.planId],
                  }),
                  ...values,
                  [fields.companyId]:
                    value || value === 0 ? parseInt(value) : null,
                });
                getPlansDropDown(get(value, "companyId", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };

              const OnSponsorChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.sponsorOrganizationId]:
                    value || value === 0 ? parseInt(value) : null,
                });

                getMasterPlanList(get(sponsors[value], "id", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };

              const selectPlanOptions =
                planList && !isEmpty(values[fields.companyName])
                  ? [
                      allOption,
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ]
                  : planList && [
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ];
              const sponsoringOrgOptions = sponsors && [
                //selectOne,
                ...sponsors.map((sponsor, index) => ({
                  label: sponsor.name,
                  value: sponsor.id,
                })),
              ];
              const companyOptions = companies && [
                ...companies.map((company, index) => ({
                  label: company.companyName,
                  value: company.companyId,
                })),
              ];

              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10 header-button-form"
                  style={{ width: "fit-content" }}
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex justify-content-between">
                    <Field
                      size="sm"
                      isRequired
                      label={`Sponsoring organization ${
                        !values[fields.companyId] ? "*" : ""
                      }`}
                      name={fields.sponsorOrganizationId}
                      value={values[fields.sponsorOrganizationId]}
                      placeholder="Select One"
                      direction="bottom"
                      disabled={values[fields.companyId]}
                      validate={(value) =>
                        ["", undefined, null].includes(value) &&
                        !values[fields.companyId]
                          ? "Select a sponsoring organization or company"
                          : null
                      }
                      options={sponsoringOrgOptions}
                      popupContent={
                        <SearchableList
                          label="Select Sponsor Organization"
                          // options={sponsoringOrganisationList}
                          options={sponsoringOrgOptions}
                          onSelect={(value) => OnSponsorChange(value)}
                          selectedValue={values[fields.sponsorOrganizationId]}
                        />
                      }
                      component={FieldDropSide}
                    />

                    <div className="d-flex ml-3">
                      <Field
                        size="sm"
                        isRequired
                        label={`Company Name ${
                          !values[fields.sponsorOrganizationId] ? "*" : ""
                        }`}
                        name={fields.companyId}
                        disabled={values[fields.sponsorOrganizationId]}
                        value={values[fields.companyId]}
                        placeholder="Select One"
                        direction="bottom"
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          !values[fields.sponsorOrganizationId]
                            ? " "
                            : null
                        }
                        options={companyOptions}
                        popupContent={
                          <SearchableList
                            label="Select Company"
                            options={companyOptions}
                            onSelect={(value) => onCompanyChange(value)}
                            selectedValue={values[fields.companyId]}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>
                    <div className="d-flex ml-3">
                      <Field
                        size="sm"
                        isRequired
                        noLabelTransform
                        label={`plan Id ${
                          !values[fields.companyName] ? "*" : ""
                        }`}
                        name={fields.planName}
                        value={values[fields.planName]}
                        placeholder="Select"
                        direction="bottom"
                        validate={(value) =>
                          values[fields.sponsorOrganizationName] &&
                          ["", undefined, null, "Select One"].includes(value)
                            ? "Select a plan"
                            : null
                        }
                        popupContent={
                          <SearchableList
                            options={selectPlanOptions}
                            onSelect={(value) => onPlanChange(value)}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>

                    <div className="d-flex ml-3 mr-3 ">
                      <Field
                        size="sm"
                        label="Run Date From"
                        noLabelTransform
                        isRequired
                        name={fields.startDate}
                        value={usDateFormat(values[fields.startDate])}
                        direction="bottom"
                        isDatePicker
                        onClear={() => setFieldValue(fields.startDate, null)}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.startDate, value)
                            }
                            value={usDateFormat(values[fields.startDate])}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>

                    <div className="d-flex ml-3 mr-3 ">
                      <Field
                        size="sm"
                        label="Run Date To"
                        isRequired
                        noLabelTransform
                        name={fields.endDate}
                        value={usDateFormat(values[fields.endDate])}
                        direction="bottom"
                        isDatePicker
                        onClear={() => setFieldValue(fields.endDate, null)}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.endDate, value)
                            }
                            value={usDateFormat(values[fields.endDate])}
                          />
                        }
                        validate={(value) => {
                          return [undefined, null, ""].includes(value) ? (
                            ""
                          ) : value < values[fields.startDate] ? (
                            <div style={{ width: "150px" }}>
                              {" "}
                              Should be ahead of "Pay date from"
                            </div>
                          ) : //? "PL559 : Pay Date From must be greater than Pay Date to"
                          undefined;
                        }}
                        component={FieldDropSide}
                      />
                    </div>

                    <div className="d-flex ml-3">
                      <div style={{ position: "relative", display: "flex" }}>
                        <Field
                          size="smd"
                          placeholder="Search SSN, Name"
                          label="Search"
                          isRequired
                          name={fields.employeeNameOrSsn}
                          type="text"
                          autoComplete="off"
                          value={values[fields.employeeNameOrSsn]}
                          onChange={handleChange}
                          component={FieldInput}
                        />
                        {values[fields.employeeNameOrSsn] &&
                          values[fields.employeeNameOrSsn].length != 0 && (
                            <div
                              style={{
                                position: "absolute",
                                right: "5px",
                                top: "5px",
                                marginTop: "30px",
                                marginRight: "5px",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faTimes}
                                color="#000"
                                size="sm"
                                onClick={() => {
                                  setFieldValue(fields.employeeNameOrSsn, "");
                                }}
                              />
                            </div>
                          )}
                      </div>
                    </div>

                    <Button
                      className="mt-12 ml-3 sort-button "
                      style={{ marginTop: "30px" }}
                      variant="secondary"
                      type="button"
                      onClick={(e) => {
                        setValues({
                          ...clearFieldValues({
                            values,
                            fieldsToClear: [
                              fields.planId,
                              fields.companyId,
                              fields.startDate,
                              fields.endDate,
                              fields.sponsorOrganizationId,
                            ],
                          }),
                        });
                        setFieldValue(fields.employeeNameOrSsn, "");
                        setFieldValue(fields.planName, "");
                      }}
                    >
                      Reset
                    </Button>

                    <Button
                      className="mt-12 sort-button "
                      //  style={{ lineHeight: "19px", marginleft: "10%" }}
                      variant="secondary"
                      type="submit"
                      style={{ marginLeft: "8px", marginTop: "30px" }}
                    >
                      Search
                    </Button>
                  </div>

                  <div
                    className="table-width grid-overflow"
                    style={{ minWidth: "0px" }}
                  >
                    <LoaderWrapper isLoading={dataLoading}>
                      <Grid
                        data={vestingReductionData} //replace it with api data
                        total={vestingReductionData.length}
                        style={{ height: "400px" }}
                        onScroll={scrollHandler}
                        resizable={true}
                        fixedScroll
                      >
                        {final.map((column, idx) => (
                          <GridColumn
                            key={idx}
                            title={column.label}
                            field={column.field}
                            filter={column.dataType}
                            width={column.width}
                            cell={
                              column.field !== "runDate"
                                ? renderValue
                                : renderValueDate
                            }
                            headerCell={ProductNameHeader}
                            columnMenu={(props) =>
                              !isEmpty(vestingReductionData) ||
                              (gridFilters &&
                                (gridFilters[column.field1] ||
                                  (column.field2 &&
                                    gridFilters[column.field2]))) ? (
                                <ColumnMenu
                                  {...props}
                                  fields={fields}
                                  sorting={sorting}
                                  setSorting={setSorting}
                                  gridFilters={gridFilters}
                                  setGridFilters={setGridFilters}
                                  field1={column.field1}
                                  field2={column.field2 ? column.field2 : null}
                                  columns={selectedColumns}
                                />
                              ) : null
                            }
                          />
                        ))}
                      </Grid>
                    </LoaderWrapper>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </ManageReportLayout>
  );
};

export default VestingReductionReportContainer;
